import { render, staticRenderFns } from "./messUpload.vue?vue&type=template&id=6152953a&scoped=true&"
import script from "./messUpload.vue?vue&type=script&lang=js&"
export * from "./messUpload.vue?vue&type=script&lang=js&"
import style0 from "./messUpload.vue?vue&type=style&index=0&id=6152953a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152953a",
  null
  
)

export default component.exports